import { render, staticRenderFns } from "./articleHighlight.vue?vue&type=template&id=65f13820&scoped=true&"
import script from "./articleHighlight.vue?vue&type=script&lang=js&"
export * from "./articleHighlight.vue?vue&type=script&lang=js&"
import style0 from "./articleHighlight.vue?vue&type=style&index=0&id=65f13820&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f13820",
  null
  
)

export default component.exports